import * as React from 'react';
import { SVGProps } from 'react';

const FullScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 10a.836.836 0 0 0-.833.833V12.5H12.5a.836.836 0 0 0-.833.833c0 .459.375.834.833.834H15a.836.836 0 0 0 .834-.834v-2.5A.836.836 0 0 0 15 10ZM5.834 7.5H7.5a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834H5a.836.836 0 0 0-.833.834v2.5c0 .458.375.833.833.833a.836.836 0 0 0 .833-.833V7.5Zm11.666-5h-15c-.917 0-1.667.75-1.667 1.667v11.666c0 .917.75 1.667 1.667 1.667h15c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667Zm-.833 13.342H3.333a.836.836 0 0 1-.833-.834V4.992c0-.459.375-.834.833-.834h13.334c.458 0 .833.375.833.834v10.016a.836.836 0 0 1-.833.834Z"
      fill="#808A9D"
    />
  </svg>
);

export default FullScreen;
